import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PetitionHeadlineBanditData } from 'src/app/pages/petitionDetails/shared/types';

import {
	PetitionDetailsPageCopyLinkBanditVariant,
	type PetitionDetailsPageCopyLinkBanditVariantQuery,
	type PetitionDetailsPageCopyLinkBanditVariantQueryVariables,
	PetitionDetailsPageFacebookBanditVariant,
	type PetitionDetailsPageFacebookBanditVariantQuery,
	type PetitionDetailsPageFacebookBanditVariantQueryVariables,
	PetitionDetailsPageWhatsAppBanditVariant,
	type PetitionDetailsPageWhatsAppBanditVariantQuery,
	type PetitionDetailsPageWhatsAppBanditVariantQueryVariables,
} from './bandits.graphql';

export async function getFacebookBanditVariantText(
	slugOrId: string,
	variantName: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionHeadlineBanditData | undefined> {
	const { data } = await fetch<
		PetitionDetailsPageFacebookBanditVariantQuery,
		PetitionDetailsPageFacebookBanditVariantQueryVariables
	>({
		query: PetitionDetailsPageFacebookBanditVariant,
		variables: { slugOrId, variantName },
		rejectOnError: false,
	});
	return (data?.petition?.bandits.facebookHeadline.variants?.variant?.data || undefined) as
		| PetitionHeadlineBanditData
		| undefined;
}

export async function getWhatsappBanditVariantText(
	slugOrId: string,
	variantName: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionHeadlineBanditData | undefined> {
	const { data } = await fetch<
		PetitionDetailsPageWhatsAppBanditVariantQuery,
		PetitionDetailsPageWhatsAppBanditVariantQueryVariables
	>({
		query: PetitionDetailsPageWhatsAppBanditVariant,
		variables: { slugOrId, variantName },
		rejectOnError: false,
	});
	return (data?.petition?.bandits.whatsappHeadline.variants?.variant?.data || undefined) as
		| PetitionHeadlineBanditData
		| undefined;
}

export async function getCopylinkBanditVariantText(
	slugOrId: string,
	variantName: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionHeadlineBanditData | undefined> {
	const { data } = await fetch<
		PetitionDetailsPageCopyLinkBanditVariantQuery,
		PetitionDetailsPageCopyLinkBanditVariantQueryVariables
	>({
		query: PetitionDetailsPageCopyLinkBanditVariant,
		variables: { slugOrId, variantName },
		rejectOnError: false,
	});
	return (data?.petition?.bandits.copylinkHeadline.variants?.variant?.data || undefined) as
		| PetitionHeadlineBanditData
		| undefined;
}

export async function getHeadlineBanditVariantText(
	shareType: string,
	slugOrId: string,
	variantName: string,
	utilityContext: UtilityContext,
) {
	switch (shareType) {
		case 'wa':
			return getWhatsappBanditVariantText(slugOrId, variantName, utilityContext);
		case 'cl_':
			return getCopylinkBanditVariantText(slugOrId, variantName, utilityContext);
		case 'fb':
			return getFacebookBanditVariantText(slugOrId, variantName, utilityContext);
		default:
			return undefined;
	}
}
